import { Core } from "@faire/design-tokens";
import { Column, Row } from "@faire/web/slate/Layout";
import { getSpacing } from "@faire/web/slate/spacing";
import { eventsThemeColors } from "@faire/web/slate/Theme/eventsThemeColors";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import styled, { css } from "styled-components";

const StyledContainer = styled(Column)<{
  $showMarketTreatment?: boolean;
}>`
  min-width: 192px;
  margin-bottom: ${getSpacing("2x")};

  ${responsiveMediaQueries.tabletAndAbove} {
    min-width: 256px;
  }

  ${({ $showMarketTreatment: showMarketTreatment }) =>
    showMarketTreatment
      ? css`
          background-color: ${eventsThemeColors.faireMarket.lightBackground};
          padding: ${getSpacing("1x", 20)};

          ${responsiveMediaQueries.tabletAndAbove} {
            padding: ${getSpacing(12, "2x")};
          }
        `
      : null}
`;

const StyledHeader = styled(Typography).attrs({ color: Core.text.subdued })<{
  $leftAlignTitle?: boolean;
}>`
  &&& {
    padding-left: 0;
    ${responsiveMediaQueries.tabletAndAbove} {
      text-align: ${({ $leftAlignTitle }) =>
        $leftAlignTitle ? "left" : "center"};
    }
  }
`;

const StyledMainTitle = styled(Typography).attrs({
  forwardedAs: "h4",
  variant: "pageHeaderSerifRegular",
  truncate: true,
  color: Core.text.default,
})<{ $leftAlignTitle?: boolean }>`
  &&& {
    padding-left: 0;
    word-break: break-word;
    white-space: normal;
    ${responsiveMediaQueries.tabletAndAbove} {
      text-align: ${({ $leftAlignTitle }) =>
        $leftAlignTitle ? "left" : "center"};
    }
  }
`;

const StyledAuxiliaryTitle = styled(Typography)`
  text-align: right;
`;

const StyledSubtitle = styled(Typography).attrs({
  color: Core.text.subdued,
})<{
  $leftAlignTitle?: boolean;
}>`
  &&& {
    padding-left: 0;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;

    ${responsiveMediaQueries.tabletAndAbove} {
      text-align: ${({ $leftAlignTitle }) =>
        $leftAlignTitle ? "left" : "center"};
    }

    ${responsiveMediaQueries.tabletAndBelow} {
      white-space: pre-wrap;
    }
  }
`;

const StyledArrowCTAContainer = styled.div<{ $isVisible: boolean }>`
  ${({ $isVisible }) =>
    !$isVisible
      ? css`
          display: none;
        `
      : ""};
`;

const StyledTextCTAContainer = styled.div<{ $isVisible: boolean }>`
  white-space: nowrap;
  margin-top: ${getSpacing(4)};

  ${({ $isVisible }) =>
    !$isVisible
      ? css`
          display: none;
        `
      : ""};
`;

const StyledMainTitleRow = styled(Row)`
  ${responsiveMediaQueries.mobile} {
    &[data-show-arrow-cta="true"] {
      padding-top: ${getSpacing("1x")};
    }
  }
`;

const StyledHeaderTaglineWrapper = styled(Column).attrs({ gap: "1x" })``;

export namespace TitleStyles {
  export const Container = StyledContainer;
  export const Header = StyledHeader;
  export const HeaderTaglineWrapper = StyledHeaderTaglineWrapper;
  export const MainTitle = StyledMainTitle;
  export const MainTitleRow = StyledMainTitleRow;
  export const AuxiliaryTitle = StyledAuxiliaryTitle;
  export const AuxiliaryTitleText = StyledTextCTAContainer;
  export const AuxiliaryTitleArrow = StyledArrowCTAContainer;
  export const Subtitle = StyledSubtitle;
}
